//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useEffect, useState } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';

import {
  Box,
} from '@mui/material';

import {
  Check,
} from '@mui/icons-material';

// === API ===
import {on, removeListener, sendMessageData} from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function ImagesMenuItem() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const [ is_detached, setIsDetached ] = useState( false );
  
  const _hover_theme = theme.palette.mode === 'light' ? 'secondary' : 'primary';
  const _icon_visibility = is_detached ? '' : 'hidden';
  const _icon = <Check sx={{visibility: _icon_visibility }} />;

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      display    : 'flex'  ,
      marginLeft : 'auto'  ,
      alignItems : 'center',
      padding    : '0.5rem'  ,
      zIndex     : '50',
      '&:hover': {
        background: theme.palette.background[_hover_theme][theme.palette.mode],
      },
    },
    icon: {
      // color: is_light ? theme.palette.primary.main : '',
    },
    text: {
      paddingLeft: '0.5rem',
    }
  }

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleUpdate( data ) {
      //-----------------------------------------------------------------
      setIsDetached( data?.is_detached )
    }

    on( 'PROKEY_IMAGES_VIEW', handleUpdate );
    sendMessageData( 'PROKEY_IMAGES_VIEW' );

    return () => {
      removeListener( 'PROKEY_IMAGES_VIEW', handleUpdate );
    }

  }, [] );

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick(event) {
    //-----------------------------------------------------------------
    sendMessageData( 'PROKEY_IMAGES_VIEW', { is_detached: !is_detached } );
  };

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.container} onClick={onClick} name='select_detach_image_btn' >
        {_icon}
        <Box sx={_styles.text}> Image </Box>
      </Box>
    );
  }

  //#endregion

  return display();
}
